/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

export interface BasketIconProps {
  color?: string
}

export function BasketIcon({ color = '#DD2A35', ...rest }: BasketIconProps) {
  return (
    <svg
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        clipRule="evenodd"
        d="M4.75 3C4.75 1.75736 5.75736 0.75 7 0.75L9 0.75C10.2426 0.75 11.25 1.75736 11.25 3C11.25 4.24264 10.2426 3.5 9 3.5H7C5.75736 3.5 4.75 4.24264 4.75 3Z"
        fill={color}
        fillRule="evenodd"
      />
      <path
        d="M2 3H14"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        clipRule="evenodd"
        d="M2.75642 4.60607H3.5L4.6505 14.25H11.3496L12.5 4.60607L13.3011 4.60602L14.2425 4.60607L12.7425 15.1061C12.6897 15.4756 12.3733 15.75 12 15.75H4.00003C3.62679 15.75 3.31035 15.4756 3.25757 15.1061L1.75757 4.60607C2 4.60607 2.75642 4.60607 2.75642 4.60607Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  )
}

export default BasketIcon
